module.exports = __webpack_public_path__ + "img/3.a968464d.png";